export interface ClockSample {
  sampledAt: string;
  offsetMs: number;
  uncertaintyMs: number;
  warning: boolean;
}
/** Positive offset means the device clock is ahead; clinical timestamps are never adjusted. */
export function sampleServerClock(
  dateHeader: string | null,
  started: number,
  completed: number,
): ClockSample | undefined {
  const server = dateHeader ? Date.parse(dateHeader) : NaN;
  if (!Number.isFinite(server) || !Number.isFinite(started) || completed < started) return undefined;
  const offsetMs = (started + completed) / 2 - server;
  return {
    sampledAt: new Date(completed).toISOString(),
    offsetMs,
    uncertaintyMs: (completed - started) / 2 + 1000,
    warning: Math.abs(offsetMs) > 120000,
  };
}
